import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

import axios from "axios";

function Addshift() {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [editId, setEditId] = useState(null);
    const routeLocation = useLocation();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [form, setForm] = useState({
        dept_id: "",
        dept_name: "",
        school_id: "",
        is_active: "",
    })

    useEffect(() => {
        if (routeLocation.state?.departmentData) {
            const departmentData = routeLocation.state.departmentData;
            setForm(departmentData);
            setEditId(departmentData.dept_id);
            window.history.replaceState({}, document.title);
        }
    }, [routeLocation]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            dept_name: form.dept_name || "",
            school_id: userObj.school_id,
            is_active: form.is_active || "A",
            action: editId !== null ? "UPDATE" : "CREATE"
        };

        if (editId !== null) {
            formData.shift_id = editId;
        }

        try {
            console.log(formData);
            const response = await axios.post(baseUrl + "/payrolldepartmentmaster/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("API Response" + response);
            setForm({
                dept_id: "",
                dept_name: "",
                school_id: "",
                is_active: "",
            });
            if (editId !== null) {
                toast.success("Record Updated Successfully");

            } else {
                toast.success("Record Added Successfully");

            }
        } catch (error) {
            console.error("Error submitting data:", error.response?.data || error.message);
            if (error.response?.data?.error?.includes("already exists")) {
                toast.error("Record already exists");
            } else {
                toast.error("Unexpected error occurred");
            }
        }
    };

    return (

     
            
            
                
                <div className='pageBody'>
                     <ToastContainer />
                    <Container fluid>

                        <div className=''>
                            <Card>

                                <Card.Body>
                                    <form className="" onSubmit={handleSubmit}>

                                        <div className=''>
                                            <Row>
                                                <Col xs={12}>
                                                    <h6 className='commonSectionTitle'>Department Details</h6>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={6} lg={4} xxl={3}>
                                                    <div className='commonInput'>
                                                        <Form.Group>
                                                            <Form.Label>Department Name<span className='requiredStar'>*</span></Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                id="dept_name"
                                                                value={form.dept_name}
                                                                placeholder='Enter Department Name'
                                                                maxLength={50}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <Button
                                                    type="button"
                                                    variant="primary"
                                                    o className="btn-info clearBtn"
                                                    onClick={() => setForm({
                                                        dept_name: "",
                                                    })}
                                                >
                                                    Reset
                                                </Button>
                                            </div>
                                            <div>
                                                <Button
                                                    type="button"
                                                    variant="primary"
                                                    className="btn-danger secondaryBtn me-2"
                                                    onClick={() => window.history.back()}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="primary"
                                                    className="btn-success primaryBtn"
                                                >
                                                    Submit
                                                </Button>
                                            </div>
                                        </div>
                                    </form>
                                </Card.Body>
                            </Card>
                        </div>
                    </Container>
             
        </div>

    );
}

export default Addshift;